var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"label__link mod--delete w-inline-block"},[(_vm.loading)?_c('v-icon',[_vm._v(" mdi-spin mdi-sync ")]):_c('img',{staticClass:"label__link-img",attrs:{"src":"/images/i-trash.svg","loading":"lazy","alt":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }